import React, { useState, useEffect } from 'react';
import { CgMore } from 'react-icons/cg';

const PackageDetailsModal = ({
  viewMode,
  setViewMode,
  packageData,
  setDeleteId,
  setPackageData,
  handleEdit,
  handleDownload,
  handleModalClose,
  saveNotes,  // New function to save the updated notes
}) => {
  const [editedNotes, setEditedNotes] = useState("");

  // Update editedNotes when packageData changes
  useEffect(() => {
    if (packageData?.notes !== undefined) {
      setEditedNotes(packageData.notes || "");
    }
  }, [packageData]);

  if (!packageData) return null;

  const handleNotesChange = (e) => {
    setEditedNotes(e.target.value);
  };

  const handleSaveNotes = () => {
    // Save the updated notes (you can call the saveNotes function here to update the backend or state)
    saveNotes(editedNotes);
  };

  return (
    viewMode && (
      <dialog className="modal modal-open bg-gray-50">
        <div className="modal-box p-6 w-full max-w-3xl relative max-h-[90vh]">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <h3 className="font-bold text-xl mb-4 sm:mb-0">View Package Details</h3>

            <div className="dropdown relative">
              <button
                tabIndex={0}
                role="button"
                className="btn m-1 bg-slate-300 text-black z-50"
              >
                <CgMore />
              </button>
              <ul
                tabIndex={0}
                className="dropdown-content menu bg-base-100 rounded-box shadow z-10 w-52 p-2 mt-2"
              >
                <li
                  onClick={() => {
                    setViewMode(false);
                    handleEdit(packageData.id);
                  }}
                >
                  <button>Edit</button>
                </li>
                <li onClick={() => handleDownload(packageData.tracking_number)}>
                  <button>Print</button>
                </li>
                <li
                  onClick={() => {
                    setViewMode(false);
                    setDeleteId(packageData.id);
                    // setPackageData({
                    //   account_id: "",
                    //   consignee: "",
                    //   delivery_service_id: "",
                    //   description: "",
                    //   notes: "",
                    //   package_value: "",
                    //   shipment_id: "",
                    //   shipper_id: "",
                    //   staff_id: "",
                    //   tracking_number: "",
                    //   weight: "",
                    // });
                  }}
                  className="text-red-500"
                >
                  <button>Delete</button>
                </li>
              </ul>
            </div>
          </div>

          {/* Package Details Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="md:col-span-2">
              <strong>Tracking Number:</strong> {packageData.tracking_number || "N/A"}
            </div>
            <div>
              <strong>Delivery Service:</strong> {packageData.deliveryService?.name || "N/A"}
            </div>
            <div>
              <strong>Shipper / Merchant:</strong> {packageData.courier?.name || "N/A"}
            </div>
            <div className="md:col-span-2">
              <strong>Account:</strong> {packageData.accounts?.name || "N/A"}
            </div>
            <div className="md:col-span-2">
              <strong>Shipment:</strong> {packageData.shipments?.shipment_number || "N/A"}
            </div>
            <div className="md:col-span-2">
              <strong>Shipment Method:</strong> {packageData.shipmentMethod?.name || "N/A"}
            </div>
            <div className="md:col-span-2">
              <strong>Package Type:</strong> {packageData.packageType?.name || "N/A"}
            </div>
            <div>
              <strong>Weight (Lbs):</strong> {packageData.weight || "0"}
            </div>
            <div className="md:col-span-2">
              <strong>Package Description/Contents:</strong>
              {packageData.description || "N/A"}
            </div>
            <div>
              <strong>Package Value (USD):</strong> {packageData.package_value ? `$${packageData.package_value}` : "0"}
            </div>
            <div className="md:col-span-2">
              <strong>Notes:</strong>
              <textarea
                className="w-full p-2 border rounded"
                value={editedNotes}
                onChange={handleNotesChange}
                rows="4"
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveNotes} // Explicit save button for notes
              >
                Save Notes
              </button>
            </div>
            <div>
              <strong>Consignee:</strong> {packageData.consignee || "N/A"}
            </div>
            <div>
              <strong>Air Way Bill:</strong> {packageData.airWayBill || "N/A"}
            </div>
          </div>

          {/* Package History Section */}
          <div className="mt-8">
            <h4 className="font-bold text-lg mb-4">Package History</h4>
            <div className="bg-gray-100 p-4 rounded">
              {packageData.statusHistories?.length > 0 ? (
                <table className="w-full table-fixed divide-y divide-gray-200">
                  <thead>
                    <tr className="bg-gray-200">
                      {/* Table Headers */}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {packageData.statusHistories.map((entry, index) => (
                      <tr key={index}>
                        {/* Status History Details */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-gray-600">No history available.</p>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-4 mt-6">
            <button type="button" className="btn" onClick={handleModalClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleDownload(packageData.tracking_number);
                handleSaveNotes(); // Save notes when print is triggered
              }}
            >
              Print
            </button>

          </div>
        </div>
      </dialog>
    )
  );
};

export default PackageDetailsModal;
